import { render, staticRenderFns } from "./CommunityAvailableList.vue?vue&type=template&id=6a24a11a&scoped=true"
import script from "./CommunityAvailableList.vue?vue&type=script&lang=js"
export * from "./CommunityAvailableList.vue?vue&type=script&lang=js"
import style0 from "./CommunityAvailableList.vue?vue&type=style&index=0&id=6a24a11a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a24a11a",
  null
  
)

export default component.exports